import type { SubscriptionType } from '@/types/subscription';

export const getMaxSafelistedChannels = ({
  subscriptionType,
}: {
  subscriptionType: SubscriptionType;
}) => {
  if (subscriptionType === 'Essentials') {
    return 1;
  }

  if (subscriptionType === 'Creator') {
    return 3;
  }

  if (subscriptionType === 'Pro' || subscriptionType === 'Business') {
    return 10;
  }

  // Deliberately generous fallback: this function feeds display copy and
  // slot rendering, not entitlements — the backend enforces the real limit.
  // An unknown tier reading "up to 10" beats locking a paying user to 1.
  return 10;
};
